import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import CreateMachineForm from "pages/vending/machine/create/CreateMachineForm";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearMachineState } from "store/reducers/vending";

const EditBasicMachineDetails = ({ machine, open, handleClose }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearMachineState());
  }, [dispatch]);
  return (
    <CustomDialog
      fullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Update basic machine details"
    >
      <Box paddingX={2}>
        <CreateMachineForm machine={machine} fullGrid={true} />
      </Box>
    </CustomDialog>
  );
};

export default EditBasicMachineDetails;
